export default "__VITE_ASSET__DkGYhMEJ__"